module.exports = __webpack_public_path__ + "img/page-31.9756fdd0.jpg";